import { useEffect, useMemo, useState } from 'react';

const useNavHeight = element => {
  // Calculates and returns the height of the nav bar
  const [navBars, setNavBars] = useState([]);
  const navHeight = useMemo(
    () =>
      navBars.length &&
      [...navBars].reduce((a, b) => a + b?.getBoundingClientRect().height, 0),
    [navBars]
  );

  useEffect(() => {
    setNavBars(document.getElementsByTagName('nav'));
  }, []);

  if (!element?.current) return null;

  return navHeight;
};

export default useNavHeight;
